import React, { createContext, useEffect, useState } from 'react';

export const ShopContext = createContext(null);

const API_URL = 'https://badtameezdil-backend.onrender.com';

const getDefaultCart = () => {
    let cart = {};

    for (let index = 0; index < 300 + 1; index++) {
        cart[index] = 0;
    }

    return cart;
};

const ShopContextProvider = (props) => {

    const [all_product, setAll_Product] = useState([]);
    const [cartItems, setCartItems] = useState(() => {

    const savedCart = localStorage.getItem('badtameezdil-cart');
    const savedTime = localStorage.getItem('badtameezdil-cart-time');

    if (savedCart && savedTime) {

        const cartAge =
            Date.now() - Number(savedTime);

        const fiveDays =
            5 * 24 * 60 * 60 * 1000;

        if (cartAge < fiveDays) {
            return JSON.parse(savedCart);
        }

        localStorage.removeItem('badtameezdil-cart');
        localStorage.removeItem('badtameezdil-cart-time');
    }

    return getDefaultCart();
});

    useEffect(() => {

    fetch(`${API_URL}/allproducts`)
        .then((response) => response.json())
        .then((data) => setAll_Product(data));

}, []);

useEffect(() => {

    const currentCart = JSON.stringify(cartItems);
    const savedCart = localStorage.getItem('badtameezdil-cart');

    // Only reset the 5-day timer when the cart actually changes
    if (currentCart !== savedCart) {

        localStorage.setItem(
            'badtameezdil-cart',
            currentCart
        );

        localStorage.setItem(
            'badtameezdil-cart-time',
            Date.now().toString()
        );

    }

}, [cartItems]);

    const addToCart = (itemId) => {

        setCartItems((prev) => ({
            ...prev,
            [itemId]: prev[itemId] + 1
        }));

        if (localStorage.getItem('auth-token')) {

            fetch(`${API_URL}/addtocart`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'auth-token': `${localStorage.getItem('auth-token')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "itemId": itemId }),
            })
                .then((response) => response.json())
                .then((data) => console.log(data));
        }
    };

    const removeFromCart = (itemId) => {

        setCartItems((prev) => ({
            ...prev,
            [itemId]: prev[itemId] - 1
        }));

        if (localStorage.getItem('auth-token')) {

            fetch(`${API_URL}/removefromcart`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'auth-token': `${localStorage.getItem('auth-token')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "itemId": itemId }),
            })
                .then((response) => response.json())
                .then((data) => console.log(data));
        }
    };

    const getTotalCartAmount = () => {

        let totalAmount = 0;

        for (const item in cartItems) {

            if (cartItems[item] > 0) {

                let itemInfo = all_product.find(
                    (product) => product.id === Number(item)
                );

                if (itemInfo) {
                    totalAmount += itemInfo.new_price * cartItems[item];
                }
            }
        }

        return totalAmount;
    };

    const getTotalCartItems = () => {

        let totalItem = 0;

        for (const item in cartItems) {

            if (cartItems[item] > 0) {
                totalItem += cartItems[item];
            }
        }

        return totalItem;
    };

    const contextValue = {
        getTotalCartItems,
        getTotalCartAmount,
        all_product,
        cartItems,
        addToCart,
        removeFromCart
    };

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;